import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';

export const GET_RESOURCE_LIBRARY_ASSET_ITEM_QUERY = gql`
    query getResourceLibraryItem($defaultLanguage: String!, $id: Int, $fullpath: String) {
        getResourceLibraryItem(defaultLanguage: $defaultLanguage, fullpath: $fullpath, id: $id) {
            id
            key
            name
            description
            brand {
                ... on object_Brand {
                    id
                }
            }
            productGroup {
                ... on object_ProductGroup {
                    id
                }
            }
            productApplication {
                ... on object_ProductApplicationSegment {
                    id
                }
                ... on object_ProductApplication {
                    id
                }
            }
            resourceType {
                ... on object_ResourceType {
                    id
                }
                ... on object_ResourceTypeGroup {
                    id
                }
            }
            expirationDate
            validFromDate
            publicationDate
            lastModificationDate
            thumbnailUrl: thumbnail
            assetLangEn: asset(language: "en") {
                ... on asset {
                    fullpath
                    mimetype
                    type
                }
            }
            assetLangDe: asset(language: "de") {
                ... on asset {
                    fullpath
                    mimetype
                    type
                }
            }
            assetLangJa: asset(language: "ja") {
                ... on asset {
                    fullpath
                    mimetype
                    type
                }
            }
            assetLangZhCn: asset(language: "zh") {
                ... on asset {
                    fullpath
                    mimetype
                    type
                }
            }
            assetLangZhTw: asset(language: "zh_Hant_TW") {
                ... on asset {
                    fullpath
                    mimetype
                    type
                }
            }
            navigationScope {
                ... on object_NavigationNode {
                    id
                }
            }
            exclusiveNavigationScope {
                ... on object_NavigationNode {
                    id
                }
            }
        }
    }
`;

export function getResourceLibraryAssetItemQueryVariables(
    localeCode: LocaleCode,
    id?: number,
    fullpath?: string
) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
        id: id ?? null,
        fullpath: fullpath ?? null,
    };
}
